import React from "react";
import { Link, NavLink, useHistory, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { showToast } from "../../Store/Actions/ToastActions";

export const Navigation = () => {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();

  var x = new Date();
  var currentTimeZoneOffsetInHours = x.getTimezoneOffset() * -1;
  console.log(currentTimeZoneOffsetInHours, x.getTimezoneOffset());
  return (
    <nav className="nav">
      <div className="nav__top">
        <div
          onClick={() => {
            history.push("/");
          }}
          className="nav__logo"
        >
          <svg
            width="143"
            height="40"
            viewBox="0 0 143 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="3"
              y="3"
              width="34"
              height="34"
              rx="8.85339"
              fill="#1E3E23"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M31.7694 20.0234C31.7694 20.0157 31.7694 20.0079 31.7694 20.0002C31.7694 13.5002 26.5002 8.23096 20.0002 8.23096C13.5002 8.23096 8.23096 13.5002 8.23096 20.0002C8.23096 26.5002 13.5002 31.7694 20.0002 31.7694C23.6973 31.7694 26.9963 30.0647 29.154 27.3983V36.9649C30.4765 36.8405 31.0517 36.6034 31.848 36.2726L31.7694 20.0234Z"
              fill="white"
            />
            <path
              d="M23.9835 19.4872C23.9835 21.2777 21.586 24.4652 20.5348 25.7804C20.2827 26.0939 19.8155 26.0939 19.5635 25.7804C18.4938 24.4652 16.1147 21.2777 16.1147 19.4872C16.1147 17.3149 17.8762 15.554 20.0491 15.554C22.2213 15.554 23.9835 17.3149 23.9835 19.4872Z"
              fill="#1E3E23"
            />
            <path
              d="M48.2148 11.21H51.9316L56.4863 22.0488L57.5391 24.6699L58.3662 22.0488L60.042 18.0957L57.0234 11.21H60.5254L61.7607 14.4863L62.9102 11.21H66.4121L63.3936 18.0957L65.1016 22.1348L66.1328 24.6699L66.9277 22.0918L71.5039 11.21H75.2207L67.8086 28H64.4355L62.9424 24.6699L61.7285 21.4365L60.5146 24.6699L59 28H55.627L48.2148 11.21ZM76.3373 24.0039C76.3373 23.3952 76.4698 22.8402 76.7348 22.3389C76.9997 21.8376 77.3972 21.4079 77.9271 21.0498C78.4571 20.6846 79.1159 20.4053 79.9037 20.2119C80.6986 20.0114 81.6224 19.9111 82.6752 19.9111C83.4558 19.9111 84.2758 19.9684 85.1351 20.083C86.0017 20.1976 86.8933 20.373 87.8099 20.6094C87.7741 20.2083 87.6524 19.8395 87.4447 19.5029C87.237 19.1592 86.947 18.8656 86.5746 18.6221C86.2094 18.3714 85.7653 18.1781 85.2426 18.042C84.7269 17.9059 84.1397 17.8379 83.4808 17.8379C83.1228 17.8379 82.7289 17.8594 82.2992 17.9023C81.8695 17.9453 81.4255 18.0098 80.9672 18.0957C80.5088 18.1816 80.0541 18.2891 79.6029 18.418C79.1589 18.5469 78.7435 18.7008 78.3568 18.8799L77.39 16.2695C77.8698 16.0977 78.3819 15.9401 78.9262 15.7969C79.4776 15.6536 80.0398 15.5319 80.6127 15.4316C81.1856 15.3242 81.7585 15.2419 82.3314 15.1846C82.9043 15.1273 83.4594 15.0986 83.9965 15.0986C86.3669 15.0986 88.1286 15.7038 89.2816 16.9141C90.4346 18.1243 91.0111 19.9792 91.0111 22.4785V28H87.8314V26.8076C87.502 27.001 87.1403 27.1836 86.7465 27.3555C86.3598 27.5273 85.9372 27.6777 85.4789 27.8066C85.0206 27.9355 84.5264 28.0358 83.9965 28.1074C83.4737 28.1862 82.9187 28.2256 82.3314 28.2256C81.3431 28.2256 80.473 28.1182 79.7211 27.9033C78.9763 27.6885 78.3532 27.3913 77.8519 27.0117C77.3506 26.6322 76.9711 26.1882 76.7133 25.6797C76.4626 25.1641 76.3373 24.6055 76.3373 24.0039ZM79.6889 23.8965C79.6889 24.1042 79.7426 24.3047 79.85 24.498C79.9574 24.6842 80.1293 24.8525 80.3656 25.0029C80.6019 25.1462 80.9027 25.2643 81.268 25.3574C81.6403 25.4434 82.0879 25.4863 82.6107 25.4863C83.1693 25.4863 83.71 25.4362 84.2328 25.3359C84.7556 25.2357 85.2426 25.1032 85.6937 24.9385C86.1449 24.7738 86.5531 24.584 86.9183 24.3691C87.2836 24.1543 87.5879 23.9323 87.8314 23.7031V23.1445C87.3445 23.0085 86.8611 22.8939 86.3812 22.8008C85.9086 22.7077 85.4538 22.6361 85.017 22.5859C84.5873 22.5286 84.1791 22.4893 83.7924 22.4678C83.4128 22.4463 83.0798 22.4355 82.7933 22.4355C82.1989 22.4355 81.7048 22.4749 81.3109 22.5537C80.917 22.6325 80.5984 22.7399 80.3549 22.876C80.1114 23.0049 79.9395 23.1589 79.8392 23.3379C79.739 23.5169 79.6889 23.7031 79.6889 23.8965ZM100.85 17.9668H94.3513V15.3242H106.748L98.9275 25.3574H106.318V28H93.0838L100.85 17.9668ZM108.144 21.6621C108.144 20.7526 108.326 19.9004 108.692 19.1055C109.064 18.3105 109.59 17.6159 110.271 17.0215C110.958 16.4271 111.785 15.958 112.752 15.6143C113.726 15.2705 114.818 15.0986 116.028 15.0986C117.239 15.0986 118.327 15.2705 119.294 15.6143C120.268 15.958 121.095 16.4271 121.776 17.0215C122.463 17.6159 122.989 18.3105 123.355 19.1055C123.727 19.9004 123.913 20.7526 123.913 21.6621C123.913 22.5716 123.727 23.4238 123.355 24.2188C122.989 25.0137 122.463 25.7083 121.776 26.3027C121.095 26.8971 120.268 27.3662 119.294 27.71C118.327 28.0537 117.239 28.2256 116.028 28.2256C114.818 28.2256 113.726 28.0537 112.752 27.71C111.785 27.3662 110.958 26.8971 110.271 26.3027C109.59 25.7083 109.064 25.0137 108.692 24.2188C108.326 23.4238 108.144 22.5716 108.144 21.6621ZM111.485 21.6621C111.485 22.1706 111.585 22.654 111.785 23.1123C111.993 23.5635 112.29 23.9645 112.677 24.3154C113.071 24.6592 113.547 24.9349 114.106 25.1426C114.671 25.3431 115.312 25.4434 116.028 25.4434C116.745 25.4434 117.382 25.3431 117.941 25.1426C118.506 24.9349 118.983 24.6592 119.369 24.3154C119.763 23.9645 120.06 23.5635 120.261 23.1123C120.469 22.654 120.572 22.1706 120.572 21.6621C120.572 21.1536 120.469 20.6702 120.261 20.2119C120.06 19.7536 119.763 19.3525 119.369 19.0088C118.983 18.6579 118.506 18.3822 117.941 18.1816C117.382 17.974 116.745 17.8701 116.028 17.8701C115.312 17.8701 114.671 17.974 114.106 18.1816C113.547 18.3822 113.071 18.6579 112.677 19.0088C112.29 19.3525 111.993 19.7536 111.785 20.2119C111.585 20.6702 111.485 21.1536 111.485 21.6621ZM125.878 21.6621C125.878 20.7526 126.061 19.9004 126.426 19.1055C126.799 18.3105 127.325 17.6159 128.005 17.0215C128.693 16.4271 129.52 15.958 130.487 15.6143C131.461 15.2705 132.553 15.0986 133.763 15.0986C134.974 15.0986 136.062 15.2705 137.029 15.6143C138.003 15.958 138.83 16.4271 139.51 17.0215C140.198 17.6159 140.724 18.3105 141.089 19.1055C141.462 19.9004 141.648 20.7526 141.648 21.6621C141.648 22.5716 141.462 23.4238 141.089 24.2188C140.724 25.0137 140.198 25.7083 139.51 26.3027C138.83 26.8971 138.003 27.3662 137.029 27.71C136.062 28.0537 134.974 28.2256 133.763 28.2256C132.553 28.2256 131.461 28.0537 130.487 27.71C129.52 27.3662 128.693 26.8971 128.005 26.3027C127.325 25.7083 126.799 25.0137 126.426 24.2188C126.061 23.4238 125.878 22.5716 125.878 21.6621ZM129.219 21.6621C129.219 22.1706 129.32 22.654 129.52 23.1123C129.728 23.5635 130.025 23.9645 130.412 24.3154C130.806 24.6592 131.282 24.9349 131.84 25.1426C132.406 25.3431 133.047 25.4434 133.763 25.4434C134.479 25.4434 135.117 25.3431 135.675 25.1426C136.241 24.9349 136.717 24.6592 137.104 24.3154C137.498 23.9645 137.795 23.5635 137.996 23.1123C138.203 22.654 138.307 22.1706 138.307 21.6621C138.307 21.1536 138.203 20.6702 137.996 20.2119C137.795 19.7536 137.498 19.3525 137.104 19.0088C136.717 18.6579 136.241 18.3822 135.675 18.1816C135.117 17.974 134.479 17.8701 133.763 17.8701C133.047 17.8701 132.406 17.974 131.84 18.1816C131.282 18.3822 130.806 18.6579 130.412 19.0088C130.025 19.3525 129.728 19.7536 129.52 20.2119C129.32 20.6702 129.219 21.1536 129.219 21.6621Z"
              fill="#1E3E23"
            />
          </svg>
        </div>
        <ul className="nav__list">
          <li className="nav__item">
            <NavLink
              exact
              className={"nav__link"}
              activeClassName={"active"}
              to={"/"}
            >
              <span className={"icon"}>
                {location.pathname == "/" ? (
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.0113 2.01416C11.1363 2.01416 10.2723 2.34716 9.60427 3.01416L2.29227 10.2951C1.90127 10.6861 1.90127 11.3421 2.29227 11.7331L4.01127 13.4521V17.0141C4.01127 19.2231 5.80227 21.0141 8.01127 21.0141H16.0113C18.2203 21.0141 20.0113 19.2231 20.0113 17.0141V13.4521L21.7293 11.7331C22.1203 11.3421 22.1203 10.6861 21.7293 10.2951C21.3903 9.95614 20.1483 8.70815 19.0113 7.57615V5.01415C19.0113 4.46215 18.5633 4.01415 18.0113 4.01415C17.4583 4.01415 17.0113 4.46215 17.0113 5.01415V5.60814C15.9413 4.54315 14.7413 3.33816 14.4173 3.01416C13.7493 2.34716 12.8853 2.01416 12.0113 2.01416Z"
                      fill="#2C3E50"
                    />
                  </svg>
                ) : (
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.0113 2.01416C11.1363 2.01416 10.2723 2.34716 9.60426 3.01416L2.29227 10.2951C1.90127 10.6861 1.90127 11.3421 2.29227 11.7331L4.01126 13.4521V17.0141C4.01126 19.2231 5.80226 21.0141 8.01126 21.0141H16.0112C18.2202 21.0141 20.0112 19.2231 20.0112 17.0141V13.4521L21.7292 11.7331C22.1202 11.3421 22.1202 10.6861 21.7292 10.2951C21.3902 9.95614 20.1482 8.70815 19.0112 7.57615V5.01415C19.0112 4.46215 18.5632 4.01415 18.0112 4.01415C17.4582 4.01415 17.0112 4.46215 17.0112 5.01415V5.60814C15.9412 4.54315 14.7413 3.33816 14.4173 3.01416C13.7493 2.34716 12.8853 2.01416 12.0113 2.01416ZM12.0113 4.01415C12.3743 4.01415 12.7343 4.14316 13.0113 4.42016C13.5453 4.95516 15.5603 6.96013 17.2923 8.70213C17.2993 8.70913 17.2853 8.72613 17.2923 8.73313C17.2983 8.73913 17.3173 8.72613 17.3233 8.73313C18.2383 9.65213 19.0393 10.4801 19.5733 11.0141L18.2922 12.2951C18.1052 12.4831 18.0112 12.7491 18.0112 13.0141V17.0141C18.0112 18.1191 17.1152 19.0141 16.0112 19.0141H8.01126C6.90626 19.0141 6.01126 18.1191 6.01126 17.0141V13.0141C6.01126 12.7491 5.91726 12.4831 5.72926 12.2951L4.44828 11.0141L11.0113 4.42016C11.2883 4.14316 11.6483 4.01415 12.0113 4.01415Z"
                      fill="#6E7A80"
                    />
                  </svg>
                )}
              </span>
              <span className={"text"}>Home</span>
            </NavLink>
          </li>
          {/* <li className="nav__item">
            <NavLink exact className={'nav__link'} activeClassName={"active"} to={'/payouts'}>
	            <span className={'icon'}>
		            {location.pathname == '/payouts' ?
			            (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				            <path fillRule="evenodd" clipRule="evenodd" d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM12.6331 10.9832C14.2245 11.3201 15.6956 11.9186 15.6956 14.0059L15.6973 14.0061C15.6973 15.5877 14.5626 16.7057 12.8126 16.9337V18.2114C12.8126 18.7292 12.4049 19.0002 12.002 19.0002C11.599 19.0002 11.1917 18.7292 11.1917 18.2114V16.9109C8.9878 16.5813 8.54593 15.1036 8.34577 14.427L8.33177 14.3649C8.3204 14.3106 8.3064 14.2435 8.3064 14.1645C8.3064 13.7491 8.60499 13.3987 9.04993 13.293L9.07727 13.2878C9.16805 13.2722 9.2433 13.2598 9.33715 13.2598C9.76743 13.2598 10.1163 13.5085 10.2264 13.8946C10.4145 14.5922 10.6958 15.2136 12.0759 15.2136C13.139 15.2136 13.7732 14.7665 13.7732 14.0164C13.7732 13.4026 13.5441 13.0638 12.2448 12.7995L11.3324 12.6057C9.94943 12.3205 8.53368 11.7537 8.53368 9.72061C8.53368 8.60323 9.22755 7.32136 11.1119 7.02648V5.77655C11.1119 4.74164 12.7328 4.74164 12.7328 5.77655V7.01905C14.487 7.27936 15.12 8.4197 15.3453 9.1442C15.3827 9.2433 15.4013 9.34523 15.4013 9.44805C15.4013 9.86258 15.0951 10.2126 14.6554 10.3001C14.5841 10.3145 14.4887 10.3307 14.3826 10.3307C13.9729 10.3307 13.6446 10.1102 13.5032 9.74051L13.4919 9.7053C13.3724 9.28136 13.0846 8.71698 11.9611 8.71698C11.0123 8.71698 10.446 9.09258 10.446 9.72105C10.446 10.2054 10.5422 10.5672 11.7896 10.8124L12.6331 10.9832Z" fill="#2C3E50"/>
			            </svg>) :
			            (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				            <path d="M12 1.5C6.20156 1.5 1.5 6.20156 1.5 12C1.5 17.7984 6.20156 22.5 12 22.5C17.7984 22.5 22.5 17.7984 22.5 12C22.5 6.20156 17.7984 1.5 12 1.5ZM12 20.7188C7.18594 20.7188 3.28125 16.8141 3.28125 12C3.28125 7.18594 7.18594 3.28125 12 3.28125C16.8141 3.28125 20.7188 7.18594 20.7188 12C20.7188 16.8141 16.8141 20.7188 12 20.7188Z" fill="#6E7A80"/>
				            <path d="M12 1.35C6.11872 1.35 1.35 6.11872 1.35 12H1.65C1.65 6.28441 6.28441 1.65 12 1.65V1.35ZM1.35 12C1.35 17.8813 6.11872 22.65 12 22.65V22.35C6.28441 22.35 1.65 17.7156 1.65 12H1.35ZM12 22.65C17.8813 22.65 22.65 17.8813 22.65 12H22.35C22.35 17.7156 17.7156 22.35 12 22.35V22.65ZM22.65 12C22.65 6.11872 17.8813 1.35 12 1.35V1.65C17.7156 1.65 22.35 6.28441 22.35 12H22.65ZM12 20.5688C7.26878 20.5688 3.43125 16.7312 3.43125 12H3.13125C3.13125 16.8969 7.1031 20.8687 12 20.8687V20.5688ZM3.43125 12C3.43125 7.26878 7.26878 3.43125 12 3.43125V3.13125C7.1031 3.13125 3.13125 7.1031 3.13125 12H3.43125ZM12 3.43125C16.7312 3.43125 20.5688 7.26878 20.5688 12H20.8687C20.8687 7.1031 16.8969 3.13125 12 3.13125V3.43125ZM20.5688 12C20.5688 16.7312 16.7312 20.5688 12 20.5688V20.8687C16.8969 20.8687 20.8687 16.8969 20.8687 12H20.5688Z" fill="#6E7A80"/>
				            <path d="M15.6958 14.006C15.6958 11.9187 14.2247 11.3202 12.6333 10.9834L11.7898 10.8125C10.5425 10.5673 10.4462 10.2055 10.4462 9.72117C10.4462 9.0927 11.0126 8.71711 11.9613 8.71711C13.0848 8.71711 13.3727 9.28148 13.4921 9.70542L13.5035 9.74064C13.6448 10.1103 13.9731 10.3308 14.3829 10.3308C14.489 10.3308 14.5843 10.3146 14.6556 10.3002C15.0953 10.2127 15.4016 9.8627 15.4016 9.44817C15.4016 9.34536 15.383 9.24342 15.3456 9.14432C15.1203 8.41982 14.4872 7.27948 12.733 7.01917V5.77667C12.733 4.74176 11.1121 4.74176 11.1121 5.77667V7.02661C9.2278 7.32148 8.53392 8.60336 8.53392 9.72073C8.53392 11.7538 9.94967 12.3206 11.3326 12.6058L12.245 12.7996C13.5444 13.0639 13.7734 13.4027 13.7734 14.0165C13.7734 14.7666 13.1393 15.2138 12.0761 15.2138C10.696 15.2138 10.4147 14.5923 10.2266 13.8947C10.1166 13.5086 9.76767 13.2599 9.33739 13.2599C9.24355 13.2599 9.1683 13.2724 9.07752 13.2879L9.05017 13.2931C8.60523 13.3988 8.30664 13.7492 8.30664 14.1646C8.30664 14.2436 8.32064 14.3108 8.33202 14.365L8.34602 14.4271C8.54617 15.1037 8.98805 16.5814 11.192 16.911V18.2115C11.192 18.7293 11.5993 19.0003 12.0022 19.0003C12.4051 19.0003 12.8129 18.7293 12.8129 18.2115V16.9338C14.5629 16.7059 15.6975 15.5878 15.6975 14.0063" fill="#6E7A80"/>
			            </svg>)
								}
							</span>
	            <span className={'text'}>Payouts</span>
						</NavLink>
          </li> */}
          <li className="nav__item">
            <NavLink
              className={"nav__link"}
              activeClassName={"active"}
              to={"/expenses"}
            >
              <span className={"icon"}>
                {location.pathname == "/expenses" ? (
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3 18V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V18C21 15.2386 18.7614 13 16 13H8C5.23858 13 3 15.2386 3 18Z"
                      fill="#2C3E50"
                    />
                    <circle cx="12" cy="6.5" r="4.5" fill="#2C3E50" />
                  </svg>
                ) : (
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M12 10C13.6569 10 15 8.65685 15 7C15 5.34315 13.6569 4 12 4C10.3431 4 9 5.34315 9 7C9 8.65685 10.3431 10 12 10ZM12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
                      fill="#6E7A80"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M9 16C6.79086 16 5 17.7909 5 20V21C5 21.5523 4.55228 22 4 22C3.44772 22 3 21.5523 3 21V20C3 16.6863 5.68629 14 9 14H15C18.3137 14 21 16.6863 21 20V21C21 21.5523 20.5523 22 20 22C19.4477 22 19 21.5523 19 21V20C19 17.7909 17.2091 16 15 16H9Z"
                      fill="#6E7A80"
                    />
                  </svg>
                )}
              </span>
              <span className={"text"}>My expenses</span>
            </NavLink>
          </li>
          <li className="nav__item">
            <NavLink
              exact
              className={"nav__link"}
              activeClassName={"active"}
              to={"/usage-history"}
            >
              <span className={"icon"}>
                {location.pathname == "/usage-history" ? (
                  <svg
                    width="19"
                    height="22"
                    viewBox="0 0 19 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M9.42188 0.124023C10.5264 0.124023 11.4219 1.01945 11.4219 2.12402H15.4219C17.0787 2.12402 18.4219 3.46717 18.4219 5.12402V18.124C18.4219 19.7809 17.0787 21.124 15.4219 21.124H3.42188C1.76502 21.124 0.421875 19.7809 0.421875 18.124V5.12402C0.421875 3.46717 1.76502 2.12402 3.42188 2.12402H7.42188C7.42188 1.01945 8.31731 0.124023 9.42188 0.124023ZM4.42188 10.124C4.42188 9.57174 4.86959 9.12402 5.42188 9.12402H13.4219C13.9742 9.12402 14.4219 9.57174 14.4219 10.124C14.4219 10.6763 13.9742 11.124 13.4219 11.124H5.42188C4.86959 11.124 4.42188 10.6763 4.42188 10.124ZM5.42188 13.124C4.86959 13.124 4.42188 13.5717 4.42188 14.124C4.42188 14.6763 4.86959 15.124 5.42188 15.124H9.42188C9.97416 15.124 10.4219 14.6763 10.4219 14.124C10.4219 13.5717 9.97416 13.124 9.42188 13.124H5.42188Z"
                      fill="#2C3E50"
                    />
                  </svg>
                ) : (
                  <svg
                    width="19"
                    height="22"
                    viewBox="0 0 19 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M9.42188 0.124023C10.5264 0.124023 11.4219 1.01945 11.4219 2.12402H15.4219C17.0787 2.12402 18.4219 3.46717 18.4219 5.12402V18.124C18.4219 19.7809 17.0787 21.124 15.4219 21.124H3.42188C1.76502 21.124 0.421875 19.7809 0.421875 18.124V5.12402C0.421875 3.46717 1.76502 2.12402 3.42188 2.12402H7.42188C7.42188 1.01945 8.31731 0.124023 9.42188 0.124023ZM4.42188 10.124C4.42188 9.57174 4.86959 9.12402 5.42188 9.12402H13.4219C13.9742 9.12402 14.4219 9.57174 14.4219 10.124C14.4219 10.6763 13.9742 11.124 13.4219 11.124H5.42188C4.86959 11.124 4.42188 10.6763 4.42188 10.124ZM5.42188 13.124C4.86959 13.124 4.42188 13.5717 4.42188 14.124C4.42188 14.6763 4.86959 15.124 5.42188 15.124H9.42188C9.97416 15.124 10.4219 14.6763 10.4219 14.124C10.4219 13.5717 9.97416 13.124 9.42188 13.124H5.42188Z"
                      fill="#6E7A80"
                    />
                  </svg>
                )}
              </span>
              <span className={"text"}>History</span>
            </NavLink>
          </li>
          <li className="nav__item">
            <NavLink
              className={"nav__link"}
              activeClassName={"active"}
              to={"/settings"}
            >
              <span className={"icon"}>
                {location.pathname == "/settings/security" ||
                location.pathname == "/settings/account" ||
                location.pathname == "/settings/payment" ? (
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z"
                      fill="#2C3E50"
                    />
                    <path
                      d="M20 14C20 13.4477 19.5523 13 19 13C18.4477 13 18 13.4477 18 14L18 21C18 21.5523 18.4477 22 19 22C19.5523 22 20 21.5523 20 21L20 14Z"
                      fill="white"
                    />
                    <path
                      d="M19 2C19.5523 2 20 2.44772 20 3V4C20 4.55229 19.5523 5 19 5C18.4477 5 18 4.55229 18 4V3C18 2.44772 18.4477 2 19 2Z"
                      fill="white"
                    />
                    <path
                      d="M13 20C13 19.4477 12.5523 19 12 19C11.4477 19 11 19.4477 11 20V21C11 21.5523 11.4477 22 12 22C12.5523 22 13 21.5523 13 21V20Z"
                      fill="white"
                    />
                    <path
                      d="M12 2C12.5523 2 13 2.44772 13 3L13 10C13 10.5523 12.5523 11 12 11C11.4477 11 11 10.5523 11 10V3C11 2.44772 11.4477 2 12 2Z"
                      fill="white"
                    />
                    <path
                      d="M6 17C6 16.4477 5.55229 16 5 16C4.44772 16 4 16.4477 4 17L4 21C4 21.5523 4.44772 22 5 22C5.55229 22 6 21.5523 6 21L6 17Z"
                      fill="white"
                    />
                    <path
                      d="M6 3C6 2.44772 5.55229 2 5 2C4.44772 2 4 2.44772 4 3L4 7C4 7.55229 4.44772 8 5 8C5.55229 8 6 7.55229 6 7L6 3Z"
                      fill="white"
                    />
                    <path
                      d="M19 11C17.8954 11 17 10.1046 17 9C17 7.89543 17.8954 7 19 7C20.1046 7 21 7.89543 21 9C21 10.1046 20.1046 11 19 11Z"
                      fill="white"
                    />
                    <path
                      d="M10 15C10 16.1046 10.8954 17 12 17C13.1046 17 14 16.1046 14 15C14 13.8954 13.1046 13 12 13C10.8954 13 10 13.8954 10 15Z"
                      fill="white"
                    />
                    <path
                      d="M3 12C3 13.1046 3.89543 14 5 14C6.10457 14 7 13.1046 7 12C7 10.8954 6.10457 10 5 10C3.89543 10 3 10.8954 3 12Z"
                      fill="white"
                    />
                  </svg>
                ) : (
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19 9C19.5523 9 20 9.44772 20 10L20 21C20 21.5523 19.5523 22 19 22C18.4477 22 18 21.5523 18 21L18 10C18 9.44772 18.4477 9 19 9Z"
                      fill="#6E7A80"
                    />
                    <path
                      d="M19 2C19.5523 2 20 2.44772 20 3V6C20 6.55228 19.5523 7 19 7C18.4477 7 18 6.55228 18 6V3C18 2.44772 18.4477 2 19 2Z"
                      fill="#6E7A80"
                    />
                    <path
                      d="M13 3C13 2.44772 12.5523 2 12 2C11.4477 2 11 2.44772 11 3L11 14C11 14.5523 11.4477 15 12 15C12.5523 15 13 14.5523 13 14L13 3Z"
                      fill="#6E7A80"
                    />
                    <path
                      d="M13 18C13 17.4477 12.5523 17 12 17C11.4477 17 11 17.4477 11 18V21C11 21.5523 11.4477 22 12 22C12.5523 22 13 21.5523 13 21L13 18Z"
                      fill="#6E7A80"
                    />
                    <path
                      d="M6 3C6 2.44772 5.55229 2 5 2C4.44772 2 4 2.44772 4 3L4 10C4 10.5523 4.44772 11 5 11C5.55228 11 6 10.5523 6 10L6 3Z"
                      fill="#6E7A80"
                    />
                    <path
                      d="M6 14C6 13.4477 5.55229 13 5 13C4.44772 13 4 13.4477 4 14L4 21C4 21.5523 4.44772 22 5 22C5.55229 22 6 21.5523 6 21L6 14Z"
                      fill="#6E7A80"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M19 11C17.3431 11 16 9.65685 16 8C16 6.34315 17.3431 5 19 5C20.6569 5 22 6.34315 22 8C22 9.65685 20.6569 11 19 11ZM19 9C18.4477 9 18 8.55228 18 8C18 7.44772 18.4477 7 19 7C19.5523 7 20 7.44772 20 8C20 8.55228 19.5523 9 19 9Z"
                      fill="#6E7A80"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M9 16C9 17.6569 10.3431 19 12 19C13.6569 19 15 17.6569 15 16C15 14.3431 13.6569 13 12 13C10.3431 13 9 14.3431 9 16ZM11 16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16Z"
                      fill="#6E7A80"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M2 12C2 13.6569 3.34315 15 5 15C6.65685 15 8 13.6569 8 12C8 10.3431 6.65685 9 5 9C3.34315 9 2 10.3431 2 12ZM4 12C4 12.5523 4.44772 13 5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12Z"
                      fill="#6E7A80"
                    />
                  </svg>
                )}
              </span>
              <span className={"text"}>Settings</span>
            </NavLink>
          </li>
        </ul>
      </div>
      <div className="nav__bottom">
        <NavLink to={"/help"} className={"nav__link"}>
          <span className={"icon"}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                fill="#6F767E"
              />
              <circle cx="12" cy="18" r="1" fill="#6F767E" />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 8C11.1307 8 10.3886 8.5551 10.1135 9.33325C9.92948 9.85396 9.35815 10.1269 8.83744 9.94284C8.31672 9.75879 8.0438 9.18747 8.22784 8.66675C8.77648 7.11451 10.2568 6 12 6C14.2091 6 16 7.79086 16 10C16 11.8638 14.7252 13.4299 13 13.874V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V13C11 12.4477 11.4477 12 12 12C13.1045 12 14 11.1046 14 10C14 8.89543 13.1045 8 12 8Z"
                fill="#6F767E"
              />
            </svg>
          </span>
          <span className={"text"}>Help & Feedback</span>
        </NavLink>
        <hr className="hr" />
        <div
          className={"nav__logout"}
          onClick={() => {
            localStorage.removeItem("userToken");
            dispatch(
              showToast({
                title: "Success",
                text: "Log out success",
                type: "success",
              })
            );
            history.push("/login");
          }}
        >
          <span className={"icon"}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.7071 7.79289C17.3166 7.40237 16.6834 7.40237 16.2929 7.79289C15.9024 8.18342 15.9024 8.81658 16.2929 9.20711L18.0858 11H9C8.44772 11 8 11.4477 8 12C8 12.5523 8.44772 13 9 13H18.0858L16.2929 14.7929C15.9024 15.1834 15.9024 15.8166 16.2929 16.2071C16.6834 16.5976 17.3166 16.5976 17.7071 16.2071L20.5 13.4142C21.2811 12.6332 21.281 11.3668 20.5 10.5858L17.7071 7.79289Z"
                fill="#6F767E"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3 5C3 3.34315 4.34315 2 6 2H12C13.6569 2 15 3.34315 15 5V6C15 6.55228 14.5523 7 14 7C13.4477 7 13 6.55228 13 6V5C13 4.44772 12.5523 4 12 4H6C5.44772 4 5 4.44772 5 5V19C5 19.5523 5.44772 20 6 20H12C12.5523 20 13 19.5523 13 19V18C13 17.4477 13.4477 17 14 17C14.5523 17 15 17.4477 15 18V19C15 20.6569 13.6569 22 12 22H6C4.34315 22 3 20.6569 3 19V5Z"
                fill="#6F767E"
              />
            </svg>
          </span>
          <span className={"text"}>Log out</span>
        </div>
      </div>
    </nav>
  );
};
